// components
import { Card } from 'react-bootstrap'
import { TextInput } from 'carbon-components-react';
// styles
import styled from 'styled-components';

const HyperLinkButtonSingle = ({
  data,
  onTextFieldChange,
  dirtyFields,
  id
}) => {

  return (
    <div>
        <CardStyled
          isDirty={dirtyFields?.sponsor_data?.hyperlink_button_text || dirtyFields?.sponsor_data?.hyperlink_button_url}
          // key={item.id ? item.id : uuidv4()}
        >
          <Card className="mb-2">
            <Card.Body>
              <TextInput
                id='hyperlink_button_text'
                labelText='Button Text'
                size="sm"
                defaultValue={Array.isArray(data?.sponsor_data?.hyperlink_button) ?  data?.sponsor_data?.hyperlink_button[0]?.button_text : data?.sponsor_data?.[id]}
                onChange={onTextFieldChange}
              />
              <div className='pt-2'>
              <TextInput
                id='hyperlink_url'
                labelText='Button Text URL'
                size="sm"
                defaultValue={Array.isArray(data?.sponsor_data?.hyperlink_button) ?  data?.sponsor_data?.hyperlink_button[0]?.url : data?.sponsor_data?.[id]}
                onChange={onTextFieldChange}
                // className="pt-4"
              />
              </div>
              {/* {fieldMap?.map((field) => {
                const defaultValue = item?.[field.id]
                const props = {
                  id: `${field.id}`,
                  key: `${field.id}`,
                  labelText: field.labelText,
                  defaultValue,
                  className: "mb-3",
                }
                const readOnlyProps = {
                  onBlur: (evt) => handleBlur(evt, item.id),
                };
                if (field.type === 'textInput') {
                  return <TextInput
                    {...props}
                    {...readOnlyProps}
                    size="sm"
                  />
                } else if (field.type === 'textArea') {
                  return <TextArea
                    {...props}
                    {...readOnlyProps}
                    rows={field.rows}
                  />
                }
              })} */}
            </Card.Body>
          </Card>
        </CardStyled>
    </div>
  )
}

const CardStyled = styled.div`
  .card {
    background-color: ${({ isDirty }) => isDirty ? '#e6f7ff' : 'inherit'};

    .bx--text-input, .bx--text-area {
      background-color: ${({ isDirty }) => isDirty ? 'white' : 'inherit'};
    }

    .card-footer {
      background: #f5f5f5; // #fafafa;
    }
  }
`

const GroupNumTagStyled = styled.span`
  font-size: 12px;
  color: black;
  background-color: #d9d9d9;
  border-radius: 10px;
  padding: 3px 6px;
`

const GroupFooterLeftStyled = styled.span`
  display: flex;
  align-items: center;
`

const IconStyled = styled.i`
  cursor: pointer;
`

export default HyperLinkButtonSingle